import React from 'react';
import PropTypes from 'prop-types';
import Col from 'base-ui/dist/Col';
import Row from 'base-ui/dist/Row';

import MenuItem from 'components/Layout/_shared/Menu/MenuItem';
import MenuSearch from 'components/Layout/_shared/Menu/MenuSearch';

export default function Menu({ items }) {
  return (
    <Row className="middle-xs">
      <Col xs="12" md="11">
        <ul id="menu-main-menu" className="menu">
          {items.map((item) => <MenuItem key={item.ID} item={item} child={item.children} />)}
        </ul>
      </Col>
      <MenuSearch />
    </Row>
  );
}

Menu.propTypes = {
  /**
   * The items to render
   */
  items: PropTypes.array,
};
